import React from 'react';
import classnames from 'classnames';

import { PlanPeriod } from '@redux/ducks/account/pricingPlan/interfaces';

import './PricingPeriodSwitch.scss';

export interface PricingPeriodSwitchProps {
  canSwitchPeriod: boolean;
  planPeriod: PlanPeriod;
  contractLength: number;
  switchPeriod: (planPeriod: PlanPeriod) => void;
}

export const PricingPeriodSwitch = ({
  canSwitchPeriod,
  planPeriod,
  contractLength,
  switchPeriod,
}: PricingPeriodSwitchProps) => (
  <div className="flex-box-row pricing-period-switch">
    <span>{t('label.contract-period')}</span>

    {canSwitchPeriod ? (
      <div className="pricing-period-switch_button_group">
        <a
          className={classnames('pricing-period-switch__button', {
            'pricing-period-switch__button--active': planPeriod === PlanPeriod.Monthly,
          })}
          onClick={() => switchPeriod(PlanPeriod.Monthly)}
        >
          {t('label.monthly')}
        </a>
        <a
          className={classnames('pricing-period-switch__button', {
            'pricing-period-switch__button--active': planPeriod === PlanPeriod.Yearly,
          })}
          onClick={() => switchPeriod(PlanPeriod.Yearly)}
        >
          {t('pricing-plan.yearly-period.label', {
            period: contractLength,
          })}
        </a>
      </div>
    ) : (
      <div className="pricing-period-switch_button_group">
        <span className="pricing-period-switch__button--disabled">
          {t('pricing-plan.yearly-period.label', {
            period: contractLength,
          })}
        </span>
      </div>
    )}
  </div>
);
